import(/* webpackMode: "eager", webpackExports: ["HeaderFr"] */ "/vercel/path0/src/components/fr/headerFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetsLibraryFr"] */ "/vercel/path0/src/components/fr/widgetsLibraryFr.comp.tsx");
